<template>
  <sa-page-layout pathResource="pathResource" :linkedit="linkedit" :btnSaveVisible="false" btnRefreshVisible @refresh="onRefresh" :linkback="linkback" btnEditVisible btnBackVisible>
    <template slot="table-header"></template>
    <template slot="toolbar">
      <!-- <div style="float: right">
        <b-button variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm" @click="onCLickScaricaPdf()">
          <i class="far fa-file-pdf"></i>
          Scarica PDF
        </b-button>
      </div> -->
      <div style="float: right">
        <b-button variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm" @click="onCLickPreview()">
          <i class="far fa-file-pdf"></i>
          Preview
        </b-button>
      </div>
    </template>
    <template slot="table-body">
      <consensi-view-component ref="cmpConsensiEditComponent"></consensi-view-component>
    </template>
    <template slot="table-footer">
      <b-modal size="lg" title="Consenso Preview Paziente" ref="mdlPreviewSceltaPaziente" @ok="onOkPreview">
        {{ previewElement }}
        <b-row v-for="(value, key, i) in previewElement" :key="i">
          <b-col cols="3" style="align-content: end; text-align: end">
            <strong>{{ key }}</strong>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="previewElement[key]"></b-form-input>
          </b-col>
        </b-row>
        <template #footer>test</template>
      </b-modal>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConsensiViewComponent from "../components/ConsensiViewComponent.vue";
import html2pdf from "html2pdf.js";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { SaPageLayout, ConsensiViewComponent },
  data() {
    return {
      showModalLoading: false,
      btnNewVisible: true,
      btnRefreshVisible: true,
      pathResource: "/",
      struttureOptions: [],
      content: "",
      id: null,
      jsonData: {},
      patientOptions: [],
      linkback: "/consensi",
      linkedit: "/consensi/edit/",
      previewElement: {},
      filtro: {
        nomeConsenso: null,
        codiceStruttura: null,
        sezione: null,
        tipologia: null,
      },
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    if (this.id != "-1") {
      this.loadConsenso();
      this.linkedit += this.id;
    }
  },
  methods: {
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onRefresh() {
      this.loadConsenso();
    },
    loadConsenso() {
      this.openShowModalLoading();
      UtilityMixin.methods.loadDataResources("/consensi/" + this.id, {}, this.loadConsensoSuccess, this.loadConsensoError);
    },
    loadConsensoSuccess(response) {
      this.jsonData = response.data.data;
      this.$refs.cmpConsensiEditComponent.init(this.jsonData);
      this.closeShowModalLoading();
      const risultati = this.jsonData.testoConsenso.match(/\${.*?}/g);
      for (let r of risultati) {
        this.$set(this.previewElement, r, null);
      }
    },
    loadConsensoError(error) {
      console.log(error);
      this.closeShowModalLoading();
    },
    onCLickPreview() {
      this.$refs.mdlPreviewSceltaPaziente.show();
    },
    onOkPreview() {
      let testoConsenso = this.jsonData.testoConsenso;
      for (let a of Object.keys(this.previewElement)) {
        let valore = this.previewElement[a];
        testoConsenso = testoConsenso.replace(`${a}`, `${valore}`);
      }
      this.jsonData.testoConsenso = testoConsenso;
      this.$refs.cmpConsensiEditComponent.init(this.jsonData);
    },
    onCLickScaricaPdf() {
      let pdfContent = this.$refs.cmpConsensiEditComponent.getPdfContent();
      const options = {
        margin: 5,
        filename: `${pdfContent.nomeConsenso}.pdf`,
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf().set(options).from(pdfContent.testoConsenso).save();
    },
  },
};
</script>

<style></style>
